import { useState } from 'react';
import { PfeilLinksIcon } from '../icons';
import { neuesProtokoll, type Objekt, type Protokoll, type UebergabeArt } from '../domain/types';
import { Markenlogo } from './Marke';

interface StartProps {
	onStart: (protokoll: Protokoll) => void;
	/** Vorausgefüllte Adresse, wenn die Übergabe von einem bestehenden Objekt aus gestartet wird. */
	objekt?: Objekt;
	/** Nur gesetzt, wenn man von der Übersicht hierher kam — beim allerersten Start gibt es noch nichts, wohin man zurückkönnte. */
	onZurueck?: () => void;
}

export function Start({ onStart, objekt, onZurueck }: StartProps) {
	const [art, setArt] = useState<UebergabeArt>('einzug');
	const [strasse, setStrasse] = useState(objekt?.strasse ?? '');
	const [plz, setPlz] = useState(objekt?.plz ?? '');
	const [ort, setOrt] = useState(objekt?.ort ?? '');

	function starten() {
		const protokoll = neuesProtokoll(art, objekt);
		protokoll.objekt = { strasse: strasse.trim(), plz: plz.trim(), ort: ort.trim() };
		onStart(protokoll);
	}

	return (
		<div className="bildschirm bildschirm--start">
			{onZurueck && (
				<button type="button" className="nebenknopf start-zurueck" onClick={onZurueck}>
					<PfeilLinksIcon width={18} height={18} />
					Zurück
				</button>
			)}

			<header className="start-kopf">
				<Markenlogo />
			</header>

			<div className="art-wahl" role="radiogroup" aria-label="Art der Übergabe">
				<button
					type="button"
					className={`art-knopf ${art === 'einzug' ? 'ist-aktiv' : ''}`}
					aria-pressed={art === 'einzug'}
					onClick={() => setArt('einzug')}
				>
					Einzug
				</button>
				<button
					type="button"
					className={`art-knopf ${art === 'auszug' ? 'ist-aktiv' : ''}`}
					aria-pressed={art === 'auszug'}
					onClick={() => setArt('auszug')}
				>
					Auszug
				</button>
			</div>

			<div className="feld-gruppe">
				<label className="feld">
					<span>Straße und Hausnummer</span>
					<input
						value={strasse}
						onChange={(e) => setStrasse(e.target.value)}
						placeholder="Musterstraße 12"
						autoComplete="off"
					/>
				</label>
				<div className="feld-reihe">
					<label className="feld feld--klein">
						<span>PLZ</span>
						<input
							value={plz}
							onChange={(e) => setPlz(e.target.value)}
							placeholder="60313"
							inputMode="numeric"
							autoComplete="off"
						/>
					</label>
					<label className="feld feld--gross">
						<span>Ort</span>
						<input
							value={ort}
							onChange={(e) => setOrt(e.target.value)}
							placeholder="Frankfurt am Main"
							autoComplete="off"
						/>
					</label>
				</div>
			</div>

			<button type="button" className="hauptknopf" onClick={starten} disabled={!strasse.trim()}>
				Rundgang starten
			</button>
		</div>
	);
}
